import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ArrowForward from '@mui/icons-material/ArrowForward';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';
import { fetchData, deleteData, activateData } from './apiService';
import { useAuth } from './AuthContext';
import { tokenIsExpired } from './authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CancelIcon from '@mui/icons-material/Cancel';
import { EditSharp, Spa } from '@mui/icons-material';


function Notification() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedEngineer, setSelectedEngineer] = useState('');
    const [transferData, setTransferData] = useState({});
    const [selectedStaff, setSelectedStaff] = useState('');
    const [staffOptions, setStaffOptions] = useState([]);
    const history = useHistory();

    const { isAuthenticated, companyId, permissions, token, userId, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // fetchData();
    }, [isAuthenticated, companyId, token, userId, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    // useEffect(() => {
    //     fetchStaff();
    //     fetchTableData();
    // }, []);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter(item =>
        Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [notificationList, setNotificationList] = useState([]);
    const StyledHeader = styled.h2`
    font-size: 24px;
    font-weight: bold;
    color: #333; /* Change the color as per your preference */
    text-transform: uppercase;
    border-bottom: 2px solid #ccc; /* Add a border for a more elegant look */
    padding-bottom: 5px; /* Adjust the padding as needed */
    margin-bottom: 20px; /* Add some bottom margin for spacing */
  `;

    useEffect(() => {
        fetchNotificationList();
    }, []);

    const fetchNotificationList = async () => {
        try {
            //const response = await axios.get(`https://localhost:7291/api/NotificationApi/${companyId}`);
            const response = await axios.get(`https://pp-api.off-ease.com/api/NotificationApi/${companyId}`);
            console.log('Response data:', response.data); // Log the response data
            if (Array.isArray(response.data.response_data) && response.data.response_data.length > 0) {
                setNotificationList(response.data.response_data);
            } else {
                console.error('Error: Response data is not an array or is empty');
            }
        } catch (error) {
            console.error('Error fetching notification list:', error);
        }
    };


    const [notificationDetails, setNotificationDetails] = useState(null); // State for holding notification details
    const [showNotificationModal, setShowNotificationModal] = useState(false); // State for managing modal visibility
    // Function to open notification modal
    const openNotificationModal = (notification) => {
        setNotificationDetails(notification);
        setShowNotificationModal(true);
    };

    // Function to close notification modal
    const closeNotificationModal = () => {
        setShowNotificationModal(false);
        setNotificationDetails(null);
    };

    const handleCloseInvoiceDialog = () => {
        setShowNotificationModal(false);
        setNotificationDetails(null);
    };

    const [showModal, setShowModal] = useState(false);

    // Function to toggle modal visibility
    const toggleModal = () => {
        setShowModal(!showModal);
    };

    const [qtyshowModal, setqtyShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [quantity, setQuantity] = useState('');


    const handleRequest = (itemId, spare, spareId, engineerId, staff, quantity, EStkId) => {
        setSelectedItem({ id: itemId, spare: spare, spareId: spareId, engineerId: engineerId, staff: staff, quantity: quantity, EStkId: EStkId });
        setqtyShowModal(true);
    };

    const handleReturn = (item) => {
        setSelectedItem(item);
        setqtyShowModal(true);
    };

    const handleCloseModal = () => {
        setqtyShowModal(false);
        setSelectedItem(null);
        setQuantity('');
    };



    const handleSubmitRequest = async () => {
        try {
            //const APIURL = `https://localhost:7291/api/StockMovementApi/${selectedItem.id}`;
            const APIURL = `https://pp-api.off-ease.com/api/StockMovementApi/${selectedItem.id}`;

            const request = {
                SparePartsID: selectedItem.spareId,
                ID: selectedItem.id,
                EngineerStockID: selectedItem.EStkId,
                StaffID: selectedItem.engineerId,
                CompanyID: companyId,
                Quantity: parseFloat(quantity),
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
                Date: new Date().toISOString(),
                IsRequest: true,
                IsReturned: false,
                IsPurchased: false,
                IsClaimed: false,
                IsFinished: false,
            };

            const response = await axios.put(APIURL, request);
            console.log('Transfer submitted successfully:', response.data);
            // Reload the window
            window.location.reload();

            // Navigate to the EngineerStockTransfer page after reloading
            history.push('/EngineerStockTransfer');
        } catch (error) {
            console.error('Error submitting transfer:', error);
        }
        console.log('Request Text:', quantity);
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className="w-full mb-2 flex">
                <div style={{ position: 'relative' }} onClick={() => openNotificationModal(notificationList)}>
                    <Tooltip title="Notifications">
                        <IconButton>
                            <NotificationsIcon />
                        </IconButton>
                    </Tooltip>
                    {notificationList.length > 0 && (
                        <div className='notification-count'>
                            {notificationList.length}
                        </div>
                    )}
                </div>
            </div>


            <Modal
                open={showNotificationModal}
                onClose={closeNotificationModal}
                className={showNotificationModal ? 'notification-modal' : ''}
                style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            >

                <div style={{ marginTop: '100px', backgroundColor: 'white', padding: '20px', borderRadius: '8px' }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px', overflowX: 'auto', overflowY: 'auto' }}>
                        <div className="flex justify-end mt-2" style={{ marginTop: '-45px' }}>
                            <Tooltip title="Close" onClick={handleCloseInvoiceDialog} style={{ cursor: 'pointer' }}>

                                <CancelIcon />
                            </Tooltip>
                        </div>
                        <h2 style={{ fontFamily: 'Tahoma, Geneva, sans-serif', fontSize: '24px', fontWeight: 'bolder', color: '#333', textAlign: 'center', color: "brown" }}>Notifications</h2>

                        {notificationList.length === 0 ? (
                            <p className="text-center">No Spare Request found</p>
                        ) : (

                            <table className="w-full">

                                <thead>
                                    <tr className="bg-gray-200">
                                        <th className="px-4 py-2">Sl.No</th>
                                        <th className="px-4 py-2">Date</th>
                                        <th className="px-4 py-2">Name</th>
                                        <th className="px-4 py-2">Spare</th>
                                        <th className="px-4 py-2">Available Stock</th>
                                        <th className="px-4 py-2">Req-Quantity</th>
                                        <th className="px-4 py-2">Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {notificationList.map((item, index) => (
                                        <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                                            <td className="px-4 py-2 border">{index + 1}</td>
                                            <td className="px-4 py-2 border">{new Date(item.date).toLocaleDateString('en-GB')}</td>
                                            <td className="px-4 py-2 border">{item.staffName}</td>
                                            <td className="px-4 py-2 border">{item.spare}</td>
                                            <td className="px-4 py-2 border">{item.currentstk}</td>
                                            <td className="px-4 py-2 border">{item.quantity}</td>
                                            <td className="px-4 py-2 border">
                                                <span style={{ color: item.type === 'Requested' ? 'red' : 'green' }}>
                                                    {item.type === 'Requested' ? (
                                                        <button aria-label="request" onClick={() => handleRequest(item.id, item.spare, item.sparePartsID, item.staffID, item.staffName, item.quantity, item.engineerStockID)} style={{ marginRight: '10px' }}>Request</button>
                                                    ) : (
                                                        <button onClick={() => handleReturn(item)}>Return</button>
                                                    )}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                {/* , item.engineerStockID */}
            </Modal>


            <Modal
                className={qtyshowModal ? 'notification-modal' : ''}
                open={qtyshowModal}
                onClose={handleCloseModal}
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}
            >
                <div style={{ marginTop: '100px', backgroundColor: 'white', borderRadius: '10px' }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '500px' }}>
                        <div className="flex justify-end mt-2" style={{ marginTop: '-45px' }}>
                            <Tooltip title="Close" onClick={handleCloseModal} style={{ cursor: 'pointer' }}>
                                <CancelIcon />
                            </Tooltip>
                        </div>
                        <h2 style={{ fontFamily: 'Tahoma, Geneva, sans-serif', fontSize: '24px', fontWeight: 'bolder', color: '#333', textAlign: 'center', color: "brown", marginTop: '-40px' }}>Stock Transfer</h2>


                        {selectedItem && (
                            <div>
                                <p><strong>Engineer:  <span style={{ color: 'blue', marginRight: '20px' }}>{selectedItem.staff}</span></strong></p>

                                <p style={{ marginTop: '-20px' }}><strong>Item: <span style={{ color: 'blue', marginRight: '20px' }}>{selectedItem.spare}</span></strong></p>

                                <p style={{ marginTop: '-20px' }}><strong>Req-Qty:  <span style={{ color: 'blue', marginRight: '20px' }}>{selectedItem.quantity}</span></strong></p>
                            </div>
                        )}

                        <label style={{ fontSize: '16px' }}>Enter the Quantity</label>
                        <div style={{ width: '500px', display: 'flex' }}>
                            <div style={{ width: '200px', display: 'flex', justifyContent: 'center' }}>
                                {/* <input
                                    type="number"
                                    value={quantity}
                                    onChange={(e) => setQuantity(e.target.value)}
                                    placeholder="Enter quantity"
                                    style={{ textAlign: 'center' }}
                                /> */}
                                <input
                                    value={quantity}
                                    onChange={(e) => {
                                        const input = e.target.value.replace(/\D/g, '');
                                        if (input.length <= 2) {
                                            setQuantity(input);
                                        }
                                    }}
                                    type="text"
                                    placeholder="Requested Qty"
                                />

                            </div>
                            <div style={{ marginLeft: '30px' }}>
                                <button
                                    onClick={handleSubmitRequest}
                                    style={{
                                        background: '#4CAF50',
                                        color: 'white',
                                        padding: '12px 20px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        textDecoration: 'none',
                                        display: 'inline-block',
                                        fontSize: '16px',
                                        transitionDuration: '0.4s',
                                        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)'
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal >

        </div >
    );
}

export default Notification;

